module.exports = __webpack_public_path__ + "img/dice-3-fill.59032945.svg";